/**常见的值枚举类型 */
export default {
  dealTypes: [
    { key: 1, text: "双抬头" },
    { key: 2, text: "单抬头" },
    { key: 4, text: "纯代理" },
    { key: 8, text: "清关服务" }
  ],
  paymentTypes: [
    { key: 1, text: "T/T 电汇" },
    { key: 2, text: "COD(支票结算)" },
    { key: 3, text: "暂不付货款" },
    { key: 4, text: "其他" },
    { key: 5, text: "T/T 电汇(正能量垫款)" }
  ],
  statusTypes: [
    { key: 0, text: "待提交" },
    { key: 1, text: "待审核" },
    { key: 2, text: "已审核" },
    { key: 3, text: "待财务审" },
    { key: 4, text: "退回" }
  ],
  hkReceivingTypes: [
    { key: 1, text: "供应商配送" },
    { key: 2, text: "正能量代提货" },
    { key: 3, text: "快递" },
    { key: 4, text: "本港库存" }
  ],
  hkStockOutTypes: [
    { key: 1, text: "正能量送货" },
    { key: 3, text: "快递" },
    { key: 5, text: "转进口" },
    { key: 2, text: "客户自提" },
    { key: 6, text: "转仓" }
  ],
  imStockOutTypes: [
    { key: 1, text: "正能量送货" },
    { key: 2, text: "客户自提" },
    { key: 3, text: "待定" },
    { key: 4, text: "快递" }
  ],
  orderBillingMethod: [
    { key: 1, text: "代理" , full:"代理费模式" },
    { key: 6, text: "运费" , full:"运费模式" },    
  ]
};
